import {Component, OnInit} from '@angular/core';
import { GeneralComponent } from '../../General/g.component';
import { AppService } from '../../App/app.service';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { NgZone } from '@angular/core';
import { MessageService } from '../message.service';

@Component({
  selector: 'app-exercise-header',
  templateUrl: './exercise-header.component.html',
  styleUrls: ['./exercise-header.component.css']
})
export class ExerciseHeaderComponent implements OnInit {

  showExerciseTip = true;
  nextUrl: string;
  hasNext = true;
  chapterLink: string;

  constructor(public appService: AppService, protected _location: Location, public messageService: MessageService) {
  }

  ngOnInit() {
    this.nextUrl = this.getNext();
    this.chapterLink = this.getChapterLink();
    this.showExerciseTip = this.appService.showTip('exerciseTips');
  }

  /** action to call, when a bacjlink was clicked */
  backClicked() {
    this._location.back();
  }

  /** calls the current Exercise to reset the state */
  resetState() {
    this.appService.currentExercise.resetState();
  }

  /** get text in right language
 * @param {string} tag - text to load
 */
  get(tag: string): string {
    return this.appService.get(tag);
  }

  /** returns the state of the Exercise */
  solved(): boolean {
    return this.appService.currentExercise.solved;
  }

  /** calls the checkSolution of the exercise */
  checkSolution() {
    this.appService.currentExercise.checkSolution();
  }

  /** calls saveState of current exercise */
  saveState() {
    this.appService.currentExercise.saveState();
  }

  /** checks whether the teachers place is visible */
  teachersPlaceIsVisible(): boolean {
    return this.appService.isTeachersPlaceVisible();
  }

  /** returns the link to next exercise */
  getNext() {
    const url: any = this.appService.currentExercise.nextClicked();
    if (url.id === undefined) {
      this.hasNext = false;
    }
    return this._location.path(false).split('/').slice(0, this._location.path(false).split('/')
      .length - 2).join('/').concat('/', url.path, '/', url.id);
  }

  /** returns the link to exercise overview */
  getChapterLink() {
    const url: any = this.appService.currentExercise.nextClicked();
    return this._location.path(false).split('/').slice(0, this._location.path(false).split('/').length - 2).join('/');
  }

  /** prints an exercise */
  print() {
    this.appService.currentExercise.preprint();
    window.print();
    this.appService.currentExercise.postprint();
  }
}
